module.exports = __webpack_public_path__ + "assets/img/teacher (37).8e09aa8e.png";